import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flowAdd",
  "use": "icon-flowAdd-usage",
  "viewBox": "0 0 28.284 28.284",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.284 28.284\" id=\"icon-flowAdd\"><path data-name=\"错误 (1)\" d=\"M7.071 21.212a10 10 0 1 1 14.142 0 10 10 0 0 1-14.142 0zm13.663-7.098a1.2 1.2 0 0 0-1.199-1.198h-4.2V8.769a1.194 1.194 0 0 0-1.193-1.193 1.194 1.194 0 0 0-1.194 1.193v4.148H8.749a1.2 1.2 0 0 0-1.198 1.199 1.2 1.2 0 0 0 1.198 1.198l4.198.001v4.2a1.2 1.2 0 0 0 1.194 1.194 1.193 1.193 0 0 0 1.193-1.194v-4.2l4.203-.002a1.2 1.2 0 0 0 1.197-1.197z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol